import React from "react";
import {Badge} from "peggirkit";
import {FormattedMessage} from "react-intl";

const SoldOutBadge = () => {
    return (
        <Badge color={"danger"}>
            <FormattedMessage id={"soldOut"}/>
        </Badge>
    );
};

export default SoldOutBadge;